export const isPercentagePriceAdjustment = (priceAdjustment) => {
    const percentage = priceAdjustment === null || priceAdjustment === void 0 ? void 0 : priceAdjustment.percentage;
    return percentage !== undefined && percentage !== null;
};
export const isFixedAmountPriceAdjustment = (priceAdjustment) => {
    const fixedAmount = priceAdjustment === null || priceAdjustment === void 0 ? void 0 : priceAdjustment.fixedAmount;
    return fixedAmount !== undefined && fixedAmount !== null;
};
